import React from 'react';
import type { WorkspaceView } from '../../../../../models/workspace';
import type { WorkspaceFormApi } from '../../hooks/useWorkspaceForm';

export interface SectionProps {
  formApi: WorkspaceFormApi;
  editing: boolean;
  view: WorkspaceView | null;
  /** The create flow shows the section's heading and intro itself, so the section leaves them out. */
  framed?: boolean;
}

/** Shared width and rhythm of a section's field grid. */
export const SECTION_GRID = 'grid max-w-4xl grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2';

/** User text for a read-only FieldRow: bidi-isolated, or null so FieldRow shows "Not set". */
export const displayText = (value?: string | null): React.ReactNode =>
  (value && value.trim() ? React.createElement('bdi', null, value) : null);

/** Bidi isolates (FSI/PDI) for user text interpolated into a translated sentence. */
export const isolate = (text: string) => `${String.fromCharCode(0x2068)}${text}${String.fromCharCode(0x2069)}`;
